
const NativeButton = (props) => <button {...props} />

const Button = ({extraClasses = '', component = null, children, ...rest}) => {
    const Component = component ? component : NativeButton;

    return (
        <Component className={`btn flex items-center transition disabled:bg-slate-100 disabled:text-slate-900 ${extraClasses}`} {...rest}>
            {children}
        </Component>
    );
}

export default Button;
export { Button }